// @flow

import handleError, {handleIEBugs} from '../helpers/errorHandler';
import cookies from 'js-cookie';
import type {Dispatch} from 'redux';

export const apiBase = '/api';

const getAuthorizationHeader = () => {
  const token = cookies.get('token');
  return token
    ? {Authorization: `Bearer ${token}`}
    : {};
};

type Body = ?string | FormData | Object;

type RequestConfig = {
  endpoint: string,
  body?: Body,
  expectBody?: boolean,
};

type FetchOptions = {
  body?: ?string | FormData,
  headers?: {[key: string]: string},
  method?: string,
};

const mergeConfig = (config?: FetchOptions = {}): FetchOptions => ({
  ...config,
  headers: {
    ...config.headers,
    ...getAuthorizationHeader(),
  },
});

const addBody = (body: ?Body): ?FetchOptions =>
  body ? {
    body: typeof body === 'string' || body instanceof FormData
      ? body
      : JSON.stringify(body),
    headers: body instanceof FormData
      ? {}
      : {'Content-Type': 'application/json'},
  } : null;

export const GET = ({endpoint}: RequestConfig = {}, dispatch: Dispatch<*>): Promise<any> =>
  fetch(`${apiBase}${endpoint}`, {...mergeConfig()})
    .then(handleError(dispatch), handleIEBugs(dispatch));

export const POST = ({endpoint, body, expectBody = true}: RequestConfig = {}, dispatch: Dispatch<*>): Promise<any> =>
  fetch(`${apiBase}${endpoint}`, {...mergeConfig({
    method: 'POST',
    ...addBody(body),
  })}).then(handleError(dispatch, expectBody), handleIEBugs(dispatch));

export const PUT = ({endpoint, body, expectBody = true}: RequestConfig = {}, dispatch: Dispatch<*>): Promise<any> =>
  fetch(`${apiBase}${endpoint}`, {...mergeConfig({
    method: 'PUT',
    ...addBody(body),
  })}).then(handleError(dispatch, expectBody), handleIEBugs(dispatch));

export const DELETE = ({endpoint}: RequestConfig = {}, dispatch: Dispatch<*>): Promise<any> =>
  fetch(`${apiBase}${endpoint}`, {...mergeConfig({method: 'DELETE'})})
    .then(handleError(dispatch, false), handleIEBugs(dispatch));



// WEBPACK FOOTER //
// ./src/helpers/request.js